import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettingsResponse } from '../types/settings-responses';
@Injectable({
  providedIn: 'root',
})
export class AuthSettingsService {
  constructor(private httpClient: HttpClient) {}

  async loadSettings(): Promise<SettingsResponse> {
    const HOSTNAME = window.location.hostname.includes('localhost')
      ? environment.hostname
      : window.location.hostname;
    const settingsUrl = 'https://api.' + HOSTNAME + '/settings/authServers';
    return this.httpClient
      .get(settingsUrl, {
        headers: {
          Accept: 'application/json',
        },
      })
      .toPromise()
      .then((response) => {
        return response as SettingsResponse;
      });
  }
}
